import {LABELS_ERRORS} from "@labels/uk/base/errors/errorsLabels";
import {LABELS_NAVIGATE} from "@view/navigate/labels/labels";
import {LABELS_TABLE} from "@ui/tableCustom/labels/labels";
import {LABELS_EXPORT} from "@containers/export/labels/labels";
import {LABELS_DATE} from "@labels/uk/base/ui/labelsDate";
import {LABELS_REPORT_BUILDER} from "@containers/reports/reportBuilder/labels/labels";

const base = {
	createReportHelper: "Для побудови звіту оберіть параметри...",
	pageCrashedTitle: "Щось пішло не так",
	pageCrashedText: "Цю частину сторінки не вдалося показати. Решта застосунку працює.",
	tryAgain: "Спробувати ще раз",
	date: "Дата",
	theme: "Тема",
	video: "Відео",
	enabledAutoTracking: "Увімкнене авто-відстеження",
	statistic: "Статистика",
	saveChanges: "Зберегти зміни",
	routesMultiple: "рейс(-ів)",
	recipient: "Одержувач",
	history: "Історія",
	cameraNumber: "Номер камери",
	conductor: "Кондуктор",
	isScanned: "Відскановано",
	messageDetails: "Деталі повідомлення",
	provider: "Провайдер",
	notIsScanned: "Не відскановано",
	deletePoint: "Видалити зупинку",
	responsible: "Відповідальний",
	trackableObjects: "Об’єкти з мітками",
	mechanic: "Механік",
	tag: "Тег",
	iccid:'ICCID (Ідентифікатор SIM-карти)',
	lastUpdated:'Останнє оновлення',
	changeCount:'Кількість змін',
	firstDetected:'Перше виявлення',
	doctor: "Лікар",
	manager: "Менеджер",
	readerCode: "Код",
	account:"Аккаунт",
	serialNumber: "Серійний номер",
	rfid: "RFID-зона",
	readers: "Зчитувачі",
	pointTemplate: "Шаблонна зупинка",
	version: "Версія",
	default: "Стандартна",
	singleVoyageDriver: "Водій разового рейсу",
	pedestrian: "Пішохід",
	garbage: "Сміттєвий бак",
	employees: "Працівники",
	sms: "Sms",
	respond: "Відправка",
	toPlan: "Запланувати",
	success: "Успіх",
	templates: "Шаблони",
	rateLimitPerMinute: "обмеження швидкості за хвилину",
	numbers: "Номери",
	action: "Дія",
	register: "Журнал",
	inbox: "Вхідні",
	settings: "Налаштування",
	send: "Відправити",
	driverCode: "Кодове слово",
	addEmployee: "Додати працівника",
	routeName: "Назва маршруту",
	showCameraSnapshots: "Фотографії",
	photos: "Фотографії",
	photo: "Фотографія",
	photosAllList: "Повний список фотографій",
	passengerCountEstimate: "Оцінка кількості пасажирів (тестовий підрахунок), на повних бусах може бути занижена",
	prediction: "Прогнозування",
	tableNumber: "Табельний номер",
	badge: "Жетон",
	user: "Користувач",
	restartVoyage: "Повернути рейс у роботу",
	restartVoyageHint: "Рейс закрився раніше часу, бо на цьому ТЗ почався інший рейс? Спершу приберіть той рейс, потім натисніть: цей знову стане активним із тим самим ТЗ і водієм. Можна до {{time}}.",
	reassignActiveVoyage: "Заміна ТЗ / водія",
	finishVoyage: "Завершити рейс",
	finishVoyageHint: "Рейс завершиться зараз, як «Зняти з рейсу» у старому плануванні. Він не видаляється: у звітах лишиться, але зарахується тільки пройдене до завершення. Після цього на цей випуск можна знову призначити те саме або інше ТЗ чи водія.",
	finishVoyageConfirm: "Рейс буде завершено зараз: у звіт піде тільки пройдене до цієї хвилини. Підтвердіть.",
	printVoyageLetter: "Роздрукувати шляховий лист",
	printVoyageLetterSaveFirst: "Спершу збережіть зміни: шляховий лист друкується з того, що вже є в системі.",
	reassignActiveVoyageHint: "Заміна діє одразу: далі рейс продовжиться з обраним ТЗ і водієм.",
	visitedWaypoints: "Відвідано зупинок",
	nextPoint: "Наступна зупинка",
	cameras: "Камери",
	monitoringPlatform: "Платформа інтелектуального моніторингу",
	cameraId: "ID Камери",
	zoneRecordingMode: "Запис відео на зупинках",
	zoneRecordingModeHint: "Вмикає запис відео, коли машина заїжджає в зупинку. Пише тільки на рейсі — поза рейсом запис не ведеться.",
	cameraPosition: "Позиція камери",
	hostName: "Хост",
	addCamera: "Додати камеру",
	editCamera: "Редагувати камеру",
	cameraCounter: "Кількість камер",
	isActive: "Фотофіксація увімкнена",
	isActiveHint: "Робить фото раз на хвилину постійно, незалежно від рейсу та зупинок.",
	passengerCounting: "Підрахунок пасажирів (тест)",
	passengerCountingShort: "Пасажири",
	cameraCounterShort: "Камер",
	zoneRecordingModeShort: "Відео на зуп.",
	cameraPositionShort: "Позиція",
	isActiveShort: "Фото",
	passengerCountingHint: "Денні фото камери (07–19) відправляються на тестовий підрахунок пасажирів. Потрібна увімкнена фотофіксація. Зміна діє протягом 10 хвилин.",
	predictedDistanceMeters: "Дистанція(м)",
	files: "Файли",
	operationType: "Тип операції",
	voyagesAudit: "Список змін планування",
	factStart: "Початок",
	totalWaypoints: "Всього зупинок",
	factEnd: "Кінець",
	predictedTime: "Прогнозований час",
	predictedToNextPoint: "Прогнозуваня до наступної зупинки",
	showAllVoyages: "Відобразити всі маршрути",
	hideAllVoyages: "Приховати всі маршрути",
	showPredictionToNextPoint: "Відображати плановий шлях до наступної зупинки",
	showPoints: "Відображати зупинки",
	activationType: "Тип активації",
	arrivalTime: "Час прибуття",
	nothingComments: "Відсутні коментарі",
	departureTime: "Час відправлення",
	enteringTheStop: "Входження на зупинку",
	scanningTrackableObject: "Сканування обєктів",
	plannedStartShort: "Плановий почт.",
	plannedEndShort: "Плановий кінц.",
	build: "Побудувати",
	tagCode: "Код",
	scanTime: "Час сканування",
	showTrackBuffer: "Відображати буфер планового треку",
	showPlannedTrack: "Відображати плановий трек",
	showDevice: "Відображати ТЗ",
	showDeviceLastInfo: "Відображати поточне місцезнаходження ТЗ",
	showDevicesLastInfo: "Відображати поточне місцезнаходження ТЗ",
	startVoyage: "Розпочати рейс",
	showTrack: "Відображати трек",
	updateDeviceAndDriver: "Змінити ТЗ та водія",
	stopVoyage: "Закінчити рейс",
	deleteVoyages: "Видалити рейси",
	youSuccessVoyagePlanning: "Ви успішно запланували",
	youSuccessDeleteVoyagePlanning: "Ви успішно видалили",
	addOrUpdateVoyages: "Додати/оновити рейси",
	latitudeAndLongitude: "Широта/Довгота",
	confirmMessageCheckClearSaved: "Ви впевненні що бажаєте продовжити? Це призведе до очистки не збережених змін",
	planned: "Запланувати",
	localSave: "Стандартне",
	serverSave: "Миттєве",
	checkAndSave: "Звірити та зберегти",
	address: "Адреса",
	notDevice: "Без ТЗ",
	voyagePlanned: "Запланувати рейси",
	voyagePlannedWithoutCheck: "Запланувати рейси без звірки",
	hasPlannedRestSchedulesInCurrentDay: "Запланувати по всім змінам даного дня",
	unknown: "Невідомий",
	clearLocalSlots: "Скасувати незбережені зміни",
	autoCompletionInMultiDays: "Автозаповнення наряду на кілька днів",
	hasPlannedDriverRestSchedulesInCurrentDay: "Додавати водія до решти змін",
	suchChangesWillOverwritten: "Такі зміни Будуть перезаписані",
	confirmTitlePlannedRestSchedulesInCurrentDay: "Ви впевненні що бажаєте запланувати інші зміни даного дня?",
	addTextTemplate: "Додати шаблон тексту",
	selectAccount: "Оберіть аккаунт",
	points: "Зупинки",
	appVersion: "Версія додатку",
	fullBoard: "Все табло",
	geoZonesHasZoomLevelControl: "Відображати геозони тільки при великому зумі",
	geoZonesHasZoomLevelControlAllGeom: "Відображати сектора тільки при великому зумі",
	tasks: "Дорученя",
	assignmentStatus: "Статус призначення",
	planCompletionTime: "Плановий час виконання",
	hasPlanCompletionTime: "Задати плановий час виконання",
	hasTimeStart: "Задати початковий",
	hasTimeEnd: "Задати кінцевий час",
	selectAllBoard: "Вибрати всі табла",
	moveLine: "Рухомий рядок",
	taskTemplate: "Шаблон доручень",
	withoutDevice: "Без ТЗ",
	template: "Шаблон",
	templateText: "Шаблон тексту",
	withoutDriver: "Без водія",
	minBrightness: "Мінімальна яскравість",
	maxBrightness: "Максимальна яскравість",
	textMoveSpeed: "Швидкість рухомого рядка",
	notDriver: "Без водія",
	configBoard: "Налаштування табла",
	text: "Текст",
	changeStatus: "Змінити статус",
	moveText: "Рухомий рядок",
	applyAs: "Застосувати як",
	placeAfterName: "Розмістити після назви зупинки",
	min1max255Message: "Поле не може бути менше 1 та більше ніж 255",
	min1max60Message: "Поле не може бути менше 1 та більше ніж 60",
	min1max75Message: "Поле не може бути менше 1 та більше ніж 75",
	targetBoards: "Обрані табла",
	actionBoards: "Дії з таблами",
	notFountTargetBoards: "Немає вибраних...",
	resetBoard: "Перезавантажити табло",
	resetModem: "Перезавантажити модем",
	resetTextLine: "Скасувати рухомі рядки",
	disabledItems: "Відключені",
	showBoard: "Відобразити табла",
	comands: "Команди",
	enabledItems: "Підключені",
	boards: "Інфор. табла",
	phoneNumber: "Телефон",
	lastConnectionTime: "Час останнього з'єднання",
	hasAutoFill: "Увімкнути автозаповнення",
	reportsList: "Список звітів",
	changeDate: "Змінити дату",
	change: "Змінити",
	onlyTrackEnvironment: "Даний функціонал доступний лише в ТРЕК середовищі",
	createVoyageLetter: "Сформувати шляхові листи",
	createVoyageLetterByTram: "Сформувати шляхові листи(трамваї)",
	createVoyageLetterByTrolleybuses: "Сформувати шляхові листи(тролейбуси)",
	errorLengthVoyageIds: "Немає запланованих випусків за даний період",
	createDayOutfit: "Сформувати денний наряд",
	createDayOutfitByTram: "Сформувати денний наряд(трамваї)",
	createDayOutfitByTrolleybuses: "Сформувати денний наряд(тролейбуси)",
	createDriverSchedule: "Сформувати розклад для водіїв",
	emptyDriverSchedule: "Немає активних розкладів для формування",
	routeInfo: "Інформація про маршрут",
	hide: "Приховати",
	notAssignedVoyagePlanned: "Не призначенні",
	assignedVoyagePlanned: "Призначенні(водій та ТЗ)",
	semiAssignedVoyagePlanned: "Напів-призначенні(тільки ТЗ)",
	viewMode: "Режим відображення",
	scaleViewMode: "Масштабування",
	defaultViewMode: "Звичайний",
	paginationViewMode: "Режим сторінок",
	listViewMode: "Оптимізований список",
	deletePlanning: "Видалити планування",
	voyagePlanning: "Планування рейсів",
	voyageStadium: "Схеми рейсів",
	notObject: "Без об'єкту",
	helperResetPageMessage: "Більша за загальну кількість",
	currentPage: "Поточна вибрана сторінка",
	updated: "Оновлено",
	showReportErrors: "Відображати помилки звіту",
	reset: "Скинути",
	clearAll: "Очистити всі",
	selectAll: "Вибрати всі",
	online: "Онлайн",
	planingDate: "Час планування",
	hideRadius: "Приховати радіус",
	showRadius: "Показати радіус",
	radius: "Радіус",
	ignoreDrains: "Ігнорувати зливи",
	ignoreFills: "Ігнорувати заправки",
	deviceActivity: "Активність об'єктів",
	oneHourLastOnline: "Онлайн менше години тому",
	beforeLastMonth: "Онлайн більше  місяця тому",
	inactive: "Не обслуговується",
	lastDay: "Онлайн менше доби тому",
	lastMonth: "Онлайн менше місяця тому ",
	lastWeek: "Онлайн менше тижня тому",
	notConnected: "Не було з'єднання",
	routingGroup: 'Маршрутна група',
	pointLatLng: 'Координати точки',
	chartActivity: "Діаграма активності",
	typeChart: "Тип графіку",
	barChart: "Стовпчаста діаграма",
	pieChart: "Кругова діаграма",
	groupInfo: 'Інформація про групу',
	relatedGroups: 'Доступні групи',
	visibleForMultiAccount: 'Видимість для мультиаккаунту',
	simpleGroup: 'Звичайна група',
	errorAccess: "У вас немає доступу...",
	vehicleModelGroup: 'Модель транспортного засобу',
	separatedRowDataColumns: "Відокремити сирі дані",
	zoomMapForShowCorrectionPoints: "Приблизьте карту для відображення корегуючих точок",
	by: "За",
	showDirectionOfMovement: "Відображати траєкторію  руху",
	point: "Зупинка",
	enabledOptimisticMode: "Увімкнути оптимізований режим",
	addComment: "Додати коментар",
	updateComment: "Оновити коментар",
	comment: "Коментар",
	comments: "Коментарі",
	edited: "ред.",
	editedAt: "Відредаговано",
	multiGroup: "Мульти група",
	message: "Повідомлення",
	fixError: "Виправте помилки",
	noAccessMessage: "Немає доступу...",
	select: "Обрати",
	selectCarrier: "Оберіть перевізника",
	selectPoint: "Оберіть зупинку",
	employee: "Працівник",
	selectPoints: "Оберіть зупинки",
	savePoint: "Зберегти зупинку",
	saveChange: "Зберегти зміни",
	download: "Завантажити",
	cancel: "Відмінити",
	entryRadius: "Радіус входження",
	pointCount: "Кількість зупинок",
	tasksCount: "Кількість доручень",
	enterRouteName: "Введіть назву маршруту",
	enterPointName: "Введіть назву зупинки",
	dateTimeStart: "Початкова дата",
	dateTimeEnd: "Кінцева дата",
	notAvailableForMobile: "Даний функціонал не доступний на мобільних девайсах",
	hidePoint: 'Приховати зупинку',
	addPoint: 'Додати зупинку',
	singleVoyage: "Разовий рейс",
	singleVoyageShort: "Раз. рейс",
	routeSettings: "Налаштування маршруту",
	showAdditionalExportInfo: "Експортувати додаткову інформацію про звіт",
	yearDate: "Року",
	reportSubmissionDate: "Дата подання звіту",
	exportSettings: "Налаштування експорту",
	organizationName: "Назва організації",
	withoutParent: "Без батька",
	table: "Таблиця",
	showLineRoute: "Відображати лінію маршруту",
	tree: "Дерево",
	showOnlyTarget: "Відобразити тільки вибрані",
	parentGroup: "Батьківська група",
	additionNumber: "Додаток №",
	theReportIsGenerated: "Звіт сформовано",
	toTheContract: "До договору",
	navigation: "Навігація",
	signature: "Підпис",
	fullName: "ПІБ",
	create: "Створення",
	update: "Оновлення",
	delete: "Видалення",
	fullNameAgentGIS: "ТОВ \"Українські Геоінформаційні Системи\"",
	odometerKM: "Швидкість, км/год",
	course: "Курс",
	changes: "Зміни",
	routes: "Маршрути",
	voyageCount: "Кількість випусків",
	geoZone: "Гео зона",
	pointInfo: "Інформація про зупинку",
	totalPoints: "Всього зупинок",
	skippedPoints: "Пропущено зупинок",
	visitedPoints: "Відвідано зупинок",
	onAllRoutes: "По всім маршрутам",
	selectDevice: "Оберіть ТЗ",
	selectGroups: "Оберіть Групи",
	selectGeoGroups: "Оберіть гео групи",
	nothingGroups: "Не знайдено груп",
	nothingDevice: "Не знайдено ТЗ",
	hasClusterGroups: "Групувати ТЗ які знаходяться близько один біля одного",
	geoZoneType: "Тип геозони",
	trackName: "Трек",
	toggleShowQueryParams: "Показати/приховати параметри треку",
	notFoundByQueryData: "За даними параметрами нічого не знайдено...",
	layer: "Шар",
	id: "ID",
	autoTracking: "Автостеження",
	lastLocation: "Останнє місце розташування",
	selectedGroups: "Обрати групи",
	selected: "Обрані",
	available: "Доступні",
	code: "Код",
	successSaveMessage: "Ви успішно зберегли дані!",
	heavyLoadsSystem: 'Велике навантаження на браузер',
	all: "Всі",
	updateGroup: "Оновити групу",
	addGroup: "Додати групу",
	addChildGroup: "Додати дочірню групу",
	forCurrentDevice: "Для вибраного ТЗ",
	resetShowLineTrackHelper: "Ви впевнені що бажаєте продовжити? Це призведе до очищення завантаженого раніше треку",
	colorTrack: "Колір треку",
	colorVoyage: "Колір випуску",
	showFullTrackIfOnlyBuild: "Відображати повний трек(синій)",
	showFullTrackIfOnlyBuildTooltip: "Відображати повний трек(пунктирним штрихом на карті) під час відображення тільки пройденого треку ТЗ",
	sectorKey: "Ключ сектору",
	minLat: "Мінімальна широта",
	maxLat: "Максимальна широта",
	minLng: "Мінімальна довгота",
	maxLng: "Максимальна довгота",
	notes: "Нотатка",
	nothingDevices: " Не знайдео ТЗ",
	details: "Детальніше",
	deviceGroups: "Групи ТЗ",
	arrivalZone: "Початкова зона",
	departureZone: "Крайня зона",
	showLineTrack: "Відображати пройдений трек",
	searchByAddress: "Пошук за адресою",
	searchByAddressOrCoordinates: "Пошук за адресою або координатами",
	timeInterval: "Часовий інтервал",
	time: "Час",
	showGeoZones: "Відобразити гео-зони",
	allSearchKeyFields: "Пошук по всім полям",
	general: "Загалом",
	total: "Всього",
	searchByCarrier: "Пошук по перевізнику",
	filterByCarrier: "Фільтр по перевізнику",
	searchByRoute: "Пошук по маршруту",
	searchField: "Поле для пошуку",
	route: "Маршрут",
	carrier: "Перевізник",
	save: "Зберегти",
	filters: "Фільтри",
	minifiedMode: "Міні-мод",
	showColumns: "Відображення колонок",
	showColumnsMinifiedModeHelper: "Налаштування відображення колонок не можливе в міні-режимі",
	device: "ТЗ",
	generalInfo: "Загальна інфо.",
	devices: "ТЗ",
	equipmentNav: "Обладнання",
	menuColor: "Колір меню",
	menuColorCustom: "Свій колір",
	menuColorAccount: "Як в акаунта",
	voyage: 'Випуск',
	heightM: "Висота, м",
	showOnlyTraveledTrack: "Відображати тільки пройдений трек",
	dataOverTime: "Дані за",
	groupDevice: "Групи ТЗ",
	waitGeneratePdf: "Завантаження пдф файлу...",
	waitLoading: "Завантаження...",
	waitGenerateExcel: "Завантаження exel файлу...",
	satelliteCount: "Кількість супутників",
	resetActive: "Скинути активність",
	HDOP: "HDOP",
	track: "Стежити",
	startTime: "Початок",
	endTime: "Завершення",
	countEvent: "Кількість подій",
	showStops: "Відображати зупинки",
	showOnTheMap: "Показати на карті",
	mileageKM: "Пробіг, км",
	mileageSpeedKm: "Пробіг(скор.), Км",
	report: 'Звіт',
	startEventTime: 'Дата початку',
	endEventTime: 'Дата кінця',
	isLoading: 'Завантаження...',
	tableFileName: 'таблиця',
	assignmentWorkDuration: 'Тривалість завдання',
	hideOnMap: 'Приховати на карті',
	notFound: 'Нічого не знайдено...',
	voyageId: 'ID Випуску',
	yes: 'Так',
	routePointOrdinal: 'Порядковий номер маршруту',
	showPoint: 'Відображати відвідані зупинки',
	isEdgePoint: 'Крайня точка',
	geoZoneName: 'Гео-зона',
	geoZoneNotes: 'Додаткова інформація',
	showGeoZone: 'Відображати гео-зони',
	showParking: 'Відображати стоянки',
	sec: 'сек',
	min: 'хв',
	hour: 'год',
	enterTime: 'Від:',
	numberStop: '№ з/п',
	routeExecution: 'Виконання маршруту',
	hasGpsSignal: 'Передача GPS сигналу',
	exitTime: 'До',
	percent: 'Відсоток',
	assignmentStartTime: 'Початок завдання',
	assignmentEndTime: 'Кінець завдання',
	percentOfCompletion: 'Відсоток виконання',
	distanceTraveled: 'Пройдена відстань',
	voyages: 'Випуски',
	hideAllVoyage: 'Приховати всі випуски',
	showAllVoyage: 'Показати всі випуски',
	hideAll: 'Приховати всі',
	showAll: 'Показати всі',
	label: 'Назва',
	importFromDevices: 'Імпортувати з девайсів',
	maxSpeedInZone: 'Максимальна швидкість',
	averageSpeedInZone: 'Середня швидкість',
	passedDistanceInZoneInKm: 'Пробіг(км)',
	voyageActivationTime: 'Час активації рейсу',
	voyageExpiredTime: 'Закінчення рейсу',
	sector: 'Сектор',
	exportRow: 'Експортувати',
	no: 'Ні',
	speedLimit: 'Обмеження швидкості',
	object: 'ТЗ',
	group: 'Група',
	objectName: 'Об\'єкт',
	hours: 'Години',
	totalMileage: 'Загал. пробіг',
	name: 'Назва',
	additionalInfo: 'Додаткова інформація',
	baseInfo: 'Основна інформація',
	minutes: 'Хвилини',
	home: 'Головна',
	scheduleArrival: 'По графіку',
	realDeparture: 'Реальний Від\'їзд',
	realArrival: 'Реальне прибуття',
	departure: 'Від\'їзд',
	arrival: 'Прибуття',
	source: 'Джерело',
	dateStart: "Дата від",
	from: "Від",
	entrance: "В'їзд",
	exited: "Виїзд",
	number: "Номер",
	enterManually: "Ввести вручну",
	scheduleName: "Назва випуску",
	scheduleOrdinal: "Номер випуску",
	to: "До",
	count: "Кількість",
	dateEnd: "Дата до",
	countCircles: "Кількість кругів",
	voyageTitle: "Назва рейсу",
	accountGroups: "Групи",
	search: "Пошук",
	accountName: "Перевізник",
	show: "Відобразити",
	toApply: "Примінити",
	
	baseSettings: "Базові налаштування",
	type: "Тип",
	groupsType: "Групи",
	accountsType: "Перевізники",
	selectAllGroups: "Вибрати всі групи",
	selectAllDevices: "Вибрати всі об'єкти",
	clearAllDevices: "Очистити всі об'єкти",
	searchByLicensePlate: "Пошук по ТЗ",
	searchByName: "Пошук по назві",
	searchByPointName: "Пошук по назві зупинки",
	fact: "Факт",
	plan: "План",
	bySchedule: "По графіку",
	stickyHeader: "Зафіксувати заголовки",
	skipped: "Проп.",
	deviceType: "Об'єкти",
	voyageName: "Назва маршруту",
	searchKey: "Пошук за",
	resetQueryParams: "Скинути параметри пошуку",
	more: "Докладніше",
	createReport: "Побудувати звіт",
	fuelLevel: 'Палива в баку',
	separateByDevice: 'Розділити по ТЗ',
	separateLines: 'окремі рядки',
	deviceName: "Назва об'єкту",
	createTrack: "Побудувати трек",
	createSeparateTrack: "Побудувати окремий трек для ТЗ",
	createSeparateGroupTrack: "Побудувати окремі треки для ТЗ",
	searchKeySettings: "Налаштування поля для пошуку",
	lat: "Широта",
	groupType: "Тип групи",
	hdop: "HDOP",
	createdDateTime: "Дата створення",
	lon: "Довгота",
	duration: "Тривалість",
	durationMinutesAndSeconds: "Тривалість(хв:сек)",
	speed: "Швидкість",
	heading: "Курс",
	altDevice: "Висота",
	status: "Статус",
	wgAddress: "WG адреса",
	lastHandshake: "Останній зв'язок",
	handshakeOnline: "На зв'язку",
	handshakeStale: "Давно не виходив на зв'язок",
	handshakeNever: "Ще не виходив на зв'язок",
	publicKey: "Public key",
	cameraSubnet: "Підмережа камер",
	pending: "Очікує",
	failed: "Помилка",
	deviceId: 'ID ТЗ',
	accountCode: 'Перевізник',
	protocolCode: 'Тип серверу',
	active: 'Активний',
	motionStatusCodeDescription: 'Статус',
	longitude: 'Довгота',
	latitude: 'Широта',
	deviceMark: 'Модель тр.засобу',
	routeGroup: 'Маршрутна група',
	latLng: 'Широта/Довгота',
	imei: 'IMEI',
	simPhoneNumber: 'Телефон',
	licensePlate: 'Держ.номер',
	displayName: 'Марка об\'єкта',
	description: 'Опис',
	equipmentType: 'Клас об\'єкту',
	lastEventTime: 'Час останніх даних',
	stopTime: 'Час останньої стоянки',
	engineHours: 'Час роботи двигуна',
	altitude: 'Висота',
	trackColor: 'Колір треку',
	GPSOdomKM: 'Показники одометра',
	countGprsTraffic: 'Gprs Трафік',
	dailyOdometer: 'Добовий одометр',
	realAddress: 'Адреса',
	visitedGeoZone: 'Геозона',
	rawData: 'Вихідні дані датчиків',
	currentVoyageId: 'ID випуску',
	flightId: 'ID рейсу',
	driver: 'Водій',
	currentVoyageRouteId: 'ID маршруту',
	currentVoyageRouteName: 'Назва маршруту',
	currentVoyageDriverName: 'Водій на маршруті',
	currentVoyageDriverPhone: 'Номер телефону водія на маршруті',
	hideLastVoyage: "Приховати останній випуск",
	showLastVoyage: "Відобразити останній випуск",
	hideLastTargetInfo: "Приховати ТЗ",
	showLastTargetInfo: "Відобразити ТЗ",
	groups: 'Групи',
	accounts: 'Аккаунти',
	downloadCsv: "Завантажити CSV",
	info: "Інфо",
	chat: "Чат",
	expected: "Очікується",
	visited: "Відвідано",
	state: {
		stopping: 'Зупинка',
		motion: 'Рух',
		parked: 'стоянка',
		towingStart: 'Буксування',
	}
	
}
export const BASE_LABELS_UK = {
	base,
	...LABELS_ERRORS,
	...LABELS_NAVIGATE,
	...LABELS_TABLE,
	...LABELS_EXPORT,
	...LABELS_DATE,
	...LABELS_REPORT_BUILDER,
	add: 'Додати',
	edit: 'Редагування',
	update: 'Оновити',
	save: 'Зберегти',
	
	columns: 'Колонки',
	name: 'Назва',
	description: 'Опис',
	fileName: 'Назва файлу',
	confirmDeleteMessage: 'Ви впевнені що хочете видалити?',
	successDeleteMessage: 'Ви успішно видалили дані!',
	logOut: 'Вийти з аккаунту',
	notFound: 'Нічого не знайдено...',
	asc: "Від меншого до більшого",
	moreDetails: "Докладніше",
	direction: "Сортування",
	cancel: "Відмінити",
	confirm: "Підтвердити",
	order: "Сортування",
	showPage: "Показувати",
	desc: "Від більшого до меншого",
	account: "Перевізник",
	confirmAction: "Підтвердіть дію",
	useAllAccounts: "Інформація зі всіх Перевізників",
	accountIdsHelper: "Якщо ви не виберете жодного Перевізнику інформація буде отримана з всіх",
	accounts: "Перевізники",
	dateStart: "Дата від",
	dateEnd: "Дата до",
	autoRefresh: "Авто-оновлення",
	device: "ТЗ",
	ok: "Ok",
	month: "Місяць",
	years: "Рік",
	back: "Назад",
	clear: "Очистити",
	column: "Колонка",
	value: "Значення",
	
	operator: "Оператор",
	yes: "Так",
	no: "Ні",
	operatorBetweenDate: "Має включатися в діапазон",
	operatorNotBetweenDate: "Виключення з діапазону",
	operatorNotInArray: "Не має містити в собі(Кілька значень)",
	operatorInArray: "Має містити в собі(Кілька значень)",
	operatorAnd: "та",
	operatorOr: "або",
	STRING: "Текст",
	DATE: "Дата",
	BOOLEAN: "Так/ні",
	multiValues: "Кілька значень",
	NUMBER: "Число",
	LOGICAL: "Логічний оператор",
	ARRAY: "Набір даних",
	updateOperator: "Оновити оператора",
	intensitySkippedPoint: "Інтенсивність пропущених зупинок",
	settingsOnePointSkippedPointForFlagIcon: "Відображати червоний прапорець якщо хоча б 1 зупинка пропущена",
	settingsSkippedPointForFlagIconTooltip: "Відсоток кількості пропущених зупинок від загальної кількості для відображення іконки червоного прапору",
	
}
